<template>
  <div style="width: 100%; height: 100%">
    <fa-icon icon="info" id="chart-description" class="icon-info" v-if="!!description">i</fa-icon>
    <canvas :id="id"></canvas>
    <b-tooltip class="show" target="chart-description" placement="bottomright" triggers="click">{{ description }}</b-tooltip>
  </div>
</template>

<script>
import {color, makeChart} from '../chart'
  import colorscheme from "../chartjs-util/colorschemes";

  export default {
    props: {
      id: {
        type: String,
        default: 'chart-canvas'
      },
      title: String,
      description: String,
      type: {
        type: String,
        default: 'line'
      },
      labels: {
        type: Array,
        default: () => null,
      },
      label_type: {
        type: String,
        default: 'category'
      },
      label_step: {
        type: String,
        default: 'day'
      },
      maxY: {
        type: Number,
        default: undefined
      },
      labelY: {
        type: String,
        default: undefined
      },
        labelX: {
            type: String,
            default: undefined
        },
      stacked: {
        type: Boolean,
        default: false
      },
      data: {
        type: Array,
        default: () => ([])
      },
    },
    methods: {
      createChart(id) {
        const ctx = document.getElementById(id)
        makeChart(ctx, {
            type: this.type,
            title: this.title,
            xAxis: {
                labelType: this.label_type,
                stepUnit: this.label_step,
                offset: this.type !== 'line',
                title: {
                    display: !!this.labelX,
                    text: this.labelX
                }
            },
            yAxis: {
              max: this.maxY,
              stacked: this.stacked,
              title: {
                display: !!this.labelY,
                text: this.labelY
              }
            },
            data: {
                ...this.labels && {labels: this.parsedLabels},
                datasets: this.hydratedData
            },
        })
      }
    },
    computed: {
      isTimeSeries() {
        return this.label_type === 'time'
      },
      parsedLabels() {
        if (!this.labels) return undefined;
        if (this.label_type !== 'time') return this.labels
        return this.labels.map(l => new Date(l))
      },
      hydratedData() {
        const colorGenerator = colorscheme();

        return this.data.map(set => {
          const currentColor = set.color || colorGenerator.next().value
          const rs = set.data.map(d => d.count)
          const minR = Math.min.apply(null, rs)
          const maxR = Math.max.apply(null, rs)
          const pointRadius = rs.map(r =>
            ((((r - minR) / (maxR - minR)) * (8 - 2)) + 2) || 3)
          const data = set.data.map(d =>
            ({...d, x: this.isTimeSeries ? new Date(d.x) : d.x}))

          return {
            borderWidth: 1,
            pointRadius,
            pointHoverRadius: pointRadius.map(r => r + 2),
            borderColor: color(currentColor).rgbString(),
            backgroundColor: color(currentColor).alpha(0.5).rgbString(),
            ...this.stacked && {stack: 'x'},

            ...set,
            data,
          }
        })
      },
    },
    mounted() {
      this.createChart(this.id)
    }
  }
</script>

<style scoped>
.icon-info {
    position: absolute;
    top: 1em;
    left: 1em;
    cursor: pointer;
}
</style>
